module.exports = __webpack_public_path__ + "images/emoji/laughing.9bd703a7e47fee323b62.png";